import { AddVehiclePanel } from "@/components/organisms";

export const AddVehicle = () => {
  return (
    <div className="mb-12 flex flex-1 flex-col">
      <AddVehiclePanel />
    </div>
  );
};
